// extracted by mini-css-extract-plugin
export default {"stepsLayout":"StepsLayout_stepsLayout__+R9Ru"};